import type { Epic } from 'redux-observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/ignoreElements';
import { pageReady } from '../../services/metrics/index.tsx';
import { READY } from '../../state/actions/app/index.tsx';
import { isWithPageReadyMetrics } from '../../state/selectors/app/index.tsx';
import type { State, Action } from '../../state/types.tsx';

const pageReadyEpic: Epic<Action, State> = (action$, store) =>
	action$
		.ofType(READY)
		.do(() => {
			isWithPageReadyMetrics(store.getState()) && pageReady();
		})
		.ignoreElements();

export default pageReadyEpic;
